import { Box } from '@mui/material'
import {
  Forum as ForumIcon,
  LocalPhone as LocalPhoneIcon,
  Smartphone as SmartphoneIcon,
  Close as CloseIcon,
} from '@mui/icons-material'
import { xxllncColor } from '../../layout/themes'
import { HandlingStatus } from './ActionFormConstants'

export const StatusIcon = ({ type }: { type: HandlingStatus }) => {
  switch (type) {
    case 'answered':
      return (
        <ForumIcon fontSize="small" sx={{ color: xxllncColor.mineShaft }} />
      )
    case 'callback':
      return (
        <LocalPhoneIcon
          fontSize="small"
          sx={{ color: xxllncColor.mineShaft }}
        />
      )
    case 'forwarded':
      return (
        <SmartphoneIcon
          fontSize="small"
          sx={{ color: xxllncColor.mineShaft, transform: 'rotate(45deg)' }}
        />
      )
    case 'aborted':
      return (
        <Box
          sx={{
            bgcolor: xxllncColor.mineShaft,
            color: '#fff',
            borderRadius: '4px',
            width: 18,
            height: 18,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CloseIcon sx={{ fontSize: 14 }} />
        </Box>
      )
    default:
      return null
  }
}
